import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import NavBar from './components/navbar';
import Home from './components/home';
import About from './components/about';
import Portfolio from './components/portfolio';
import Contact from './components/contact';
import { HashRouter, Route, Routes } from "react-router-dom";

function Spa() {

  return (
    <HashRouter>
      <NavBar/>
      <Contact />
        <div className="container" style={{padding: "20px"}}>
          <Routes>
          <Route path="/" exact element={<Home/>} />
          <Route path="/portfolio/" element={<Portfolio/>} />
          <Route path="/about/" element={<About/>} />
          </Routes>
        </div>       
    </HashRouter>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <Spa />
  </React.StrictMode>,
  document.getElementById('root')
);

